<template>
  <div id="app" class='container'>
    <router-view class='container'/>
  </div>
</template>

<script>

export default {
  name: "App"
};
</script>

<style lang='less'>
@import 'Common/Style/index';

.spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
}
// 全局样式
.g-wx {
    display: flex;
    align-items: center;
}
.g-wx-photo {
    display: block;
    max-width: 40px;
    max-height: 40px;
    margin: 0 6px;
    border-radius: 2px;
}
.g-h-button {
    .ivu-btn {
        margin-right: 5px;
        &:last-child {
            margin: 0;
        }
    }
}
.g-goods {
    width: 100%;
    display: flex;
    // justify-content: flex-start!important;
    .g-goods-imgOne {
        max-height: 40px;
        margin: 0 6px;
    }
}

.order-goods {
  width: 100%;
  display: flex;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
 
  .order-goods-p {
    max-height: 40px;
    margin: 0 6px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    .order-goods-imgOne {
      max-height: 40px;
    }
  }
}
//滚动条样式
::-webkit-scrollbar{
  width: 5px;
  height: 5px;
}
::-webkit-scrollbar-thumb{
  border-radius: 1em;
  background-color: rgba(50,50,50,.3);
}
::-webkit-scrollbar-track{
  border-radius: 1em;
  background-color: rgba(50,50,50,.1);
}
</style>



// WEBPACK FOOTER //
// src/App.vue